import moment from 'moment';
import { parseI18nDisplayDate } from 'ecs-react-components/dist/index.es';

export const mapThreads = (config, language, timeZoneOffset, nowDate) => {
  if (!config) {
    return [];
  }

  return config.map((thread) => {
    const mapped = { ...thread };
    const nowMoment = nowDate ? moment(nowDate) : moment();
    mapped.lastMessageDate = parseI18nDisplayDate(
      mapped.lastMessageDate || null,
      language,
      nowMoment,
      timeZoneOffset);
    mapped.referencedPatientDateOfBirth = parseI18nDisplayDate(
      mapped.referencedPatientDateOfBirth || null,
      language,
      nowMoment,
      timeZoneOffset
    );
    mapped.members = mapped.members.map(
      (member) => ({ ...member,
        areMessagesReviewed:
          member.statusData && member.statusData.length > 0 && member.visibleNumberOfMessages
            ? member.visibleNumberOfMessages === member.statusData.filter((sd) => sd.reviewedOnDate).length
            : false })
    );
    return mapped;
  });
};

export const mapMessages = (messages, language, timeZoneOffset, nowDate) => {
  if (!messages) {
    return [];
  }
  return messages.map((message) => {
    const mapped = { ...message };
    const nowMoment = nowDate ? moment(nowDate) : moment();
    mapped.displayDate = parseI18nDisplayDate(
      message.messageDate,
      language,
      nowMoment,
      timeZoneOffset,
      true);
    mapped.displayName = message.senderDisplayName;
    return mapped;
  });
};
